import './styles/App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { LicenseInfo } from '@mui/x-license';
import { ThemeProvider } from './context/ThemeContext';
import Box from '@mui/material/Box';
import { useCookies } from 'react-cookie';
import { useUserContextController } from './context/UserContext';
import LoadingComponent from './components/loading';
import { AppRoutes } from './components/routes/AppRoutes';
import { useUserInitialization } from './hooks/useUserInitialization';
import { useSessionExpiredHandler } from './hooks/useSessionExpiredHandler';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY ?? '');

function App() {
  const [cookies] = useCookies(['user_session_token']);
  const [userContext] = useUserContextController();
  const { user, isUserLoading } = userContext;
  const { user_session_token } = cookies;

  useUserInitialization(user_session_token);
  useSessionExpiredHandler();

  // Session cookie can update a frame before `user` is populated; also child route
  // layout effects can run before this tree's layout effects. Don't mount routes
  // until we have a user when a token is present.
  const sessionPending = Boolean(user_session_token) && !user;
  const showRoutesLoading = isUserLoading || sessionPending;

  return (
    <ThemeProvider>
      <Router>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            width: '100vw'
          }}
        >
          {showRoutesLoading ? (
            <LoadingComponent message="Fetching user data..." />
          ) : (
            <AppRoutes isAdmin={user?.isAdmin} />
          )}
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
